import Swiper from 'swiper';

const moduleName = 'special';

export function special() {

    Array.from(document.querySelectorAll('.js-special')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const special = self;
        const specialSlider = special.querySelector('.js-special-slider');
        const specialSlides = special.querySelectorAll('.js-special-slide');
        const specialPagination = special.querySelector('.js-special-pagination');
        const specialSwiper = new Swiper(specialSlider, {
            init: false,
            slidesPerView: 3,
            spaceBetween: 30,
            simulateTouch: false,
            pagination: {
                el: specialPagination,
                clickable: true,
                bulletClass: 'pagination__bullet',
                bulletActiveClass: '_active'
            },
            breakpoints: {
                567: {
                    slidesPerView: 1
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                1023: {
                    slidesPerView: 2
                }
            },
            on: {
                resize: togglePagination,
                init: togglePagination
            }
        });

        specialSwiper.init();



        function togglePagination() {
            if (specialSlides.length > specialSwiper.params.slidesPerView) {
                specialPagination.classList.remove('_hidden');
            } else {
                specialPagination.classList.add('_hidden');
            }
        }
    });

}